import { useState } from "react";
import {
  Icon,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
  useTheme,
} from "@mui/material";
import Usuario from "../../../../../models/usuario";
import { IconBookmark, IconBookmarkOff } from "@tabler/icons-react";
import UsuarioDb from "../../../../../db/usuarioDb";
import { deleteField, updateDoc } from "firebase/firestore";
import { map } from "lodash";
import { Flags } from "../../../../../models/enum";

type Props = {
  cliente: Usuario;
};
export default function FlagCliente({ cliente }: Props) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const openMenu = !!anchorEl;
  const flags: Flags[] = Object.values(Flags);

  async function flagCliente(value: Flags | undefined) {
    const flag = value || deleteField();
    await updateDoc(new UsuarioDb().doc({ usuarioId: cliente.id }), {
      flag: flag,
    });
  }

  return (
    <>
      <Tooltip title="Marque seu cliente e filtre no Painel">
        <IconButton
          size="small"
          color={cliente.flag}
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <Icon color={cliente.flag || "disabled"}>
            <IconBookmark
              fill={
                !!cliente.flag
                  ? theme.palette[cliente.flag].main
                  : "transparent"
              }
            />
          </Icon>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={() => setAnchorEl(null)}
      >
        {map(flags, (value) => (
          <MenuItem
            key={value}
            dense
            onClick={() => {
              flagCliente(value);
              setAnchorEl(null);
            }}
          >
            <ListItemIcon>
              <Icon color={value}>
                <IconBookmark />
              </Icon>
            </ListItemIcon>
          </MenuItem>
        ))}
        <MenuItem
          dense
          onClick={() => {
            flagCliente(undefined);
            setAnchorEl(null);
          }}
        >
          <ListItemIcon>
            <Icon color="inherit">
              <IconBookmarkOff />
            </Icon>
          </ListItemIcon>
        </MenuItem>
      </Menu>
    </>
  );
}
